// config
import {setDatasets} from "../../components/charts/helpers";
import { social } from "../../config/sourceShortcuts";

export default {
  computed: {
    showZeroData() {
      return this.$store.getters.getZeroData(this.chartName);
    },
    dataBarCollection() {
      if (Object.keys(this.data).length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets()
        };
      }

      return {};
    }
  },
  methods: {
    getTotal(elem) {
      return elem.total.reduce((sum, elem) => {
        return sum + elem[1];
      }, 0);
    },
    getDataBySource(tonal) {
      let networkSum = [];
      let socialSum = [];

      Object.entries(this.data).forEach( item => {
        if (Object.keys(social.items).includes(item[0]) && this.socialList.includes(item[0])){
          networkSum.push(this.data[item[0]][tonal].reduce((sum, elem) => {
            return sum + elem[1];
          }, 0));
        }
      });

      if (networkSum.length) {
        socialSum.push(networkSum.reduce((sum, elem) => {
          return sum + elem;
        }, 0));
      }

      if (this.data[social.excluded.name] && this.socialList.includes(social.excluded.name)) {
        socialSum.push(this.data[social.excluded.name][tonal].reduce((sum, elem) => {
          return sum + elem[1];
        }, 0));
      }

      return socialSum;
    },
    getDataSets() {
      return [
        {
          label: this.$t('feed.analytics.bySourceAndGsm.body.tonal[0].title'),
          position: "top",
          backgroundColor: "#b3bccc",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("netural"),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.analytics.bySourceAndGsm.body.tonal[1].title'),
          position: "bottom",
          backgroundColor: "#f75b5b",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("negative"),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.analytics.bySourceAndGsm.body.tonal[2].title'),
          position: "top",
          backgroundColor: "#15cf49",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.getDataBySource("positive"),
          showLabel: this.showLabel,
        }
      ];
    },
    getLabels() {
      let sourceOf = [];
      let socialTotal = 0;
      let gsTotal = 0;

      let social = this.$t('feed.analytics.bySourceAndGsm.social');
      let socialKeys = Object.keys(social.items);

      socialKeys.forEach(item => {
        if (this.data[item]) {
          socialTotal += this.getTotal(this.data[item]);
        }
      });

      gsTotal = this.getTotal(this.data[social.excluded.name]);

      if (socialKeys.some(item => Object.keys(this.data).includes(item) && this.socialList.includes(item))) {
        if (this.showZeroData) {
          sourceOf.push(social.name.split(" "));
        } else {
          if(socialTotal) {
            sourceOf.push(social.name.split(" "));
          }
        }
      }

      if (Object.keys(this.data).includes(social.excluded.name) && this.socialList.includes(social.excluded.name)) {
        if (this.showZeroData) {
          sourceOf.push(social.excluded.title);
        } else {
          if(gsTotal) {
            sourceOf.push(social.excluded.title);
          }
        }
      }

      return  sourceOf;
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true,
              callback: function(value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.2,
            stacked: true,
            ticks: {
              padding: 50,
              beginAtZero: true
            },
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            }
          }],
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            color: (ctx) => {
              return ctx.dataset.backgroundColor;
            },
            formatter: function(value, ctx) {
              const datasets = setDatasets(ctx);
              let sum = 0;

              datasets.forEach(item => {
                sum += item.data[ctx.dataIndex];
              });

              if(((value / sum) * 100) === 0) {
                return "";
              }

              const byModule =  ((value / sum) * 100) % 1;
              const quotient = value / sum;

              if(!byModule) {

                if(isNaN(quotient)) {
                  return  "";
                }

                return `${((value / sum) * 100).toFixed(0)}%`;
              }

              return  `${(quotient * 100).toFixed(2)}%`;
            },
            anchor: "center",
            offset: (ctx) => {
              return ctx.dataset.data.length === 1 ? 15 : 7;
            },
            align: (ctx) => {
              return ctx.dataset.position;
            },
            font: {
              weight: "bold",
              size: 10,
              family: "Roboto"
            }
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
